export const getExpiredPasswordResult = (expiredPasswordToken) => ({ type: "expiredPassword", expiredPasswordToken });
export const getTermsResult = (jwtToken, secondStepToken) => ({ type: "terms", jwtToken, secondStepToken });
export const getApiErrorResult = (error) => (Object.assign(Object.assign({ type: "apiError" }, error), { message: error.apiErrorString }));
export const getSuccessResult = (storablePassword) => ({ type: "success", storablePassword });
export const changePasswordResult = { type: "changePassword" };
export const failedLoginResult = { type: "fail" };
//# sourceMappingURL=LoginResult.js.map